import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import members from "../assets/image/members.svg";
import announcement from "../assets/image/announcement.svg";
import events from "../assets/image/event.svg";
import logo from "../assets/image/rccglogo.webp";

function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total_members: 0,
    unread_announcements: 0,
    upcoming_events: 0,
  });

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
  
  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          toast.error("Please log in to access your dashboard.", {
            theme: "colored",
          });
          return;
        }

        const headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        };

        const dashboardRes = await fetch(
          `${TEST_BASE_URL}/dashboard`,
          { headers }
        );

        if (dashboardRes.status === 401) {
          toast.error("Session expired. Please log in again.", {
            theme: "colored",
          });
          localStorage.removeItem("authToken");
          window.location.href = "/login";
          return;
        }

        const contentType = dashboardRes.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          toast.error("Unexpected response from server.", { theme: "colored" });
          return;
        }

        const dashboardData = await dashboardRes.json();

        if (!dashboardRes.ok) {
          toast.error(
            dashboardData.message || "Failed to fetch dashboard data.",
            {
              theme: "colored",
            }
          );
          return;
        }

        let unreadCount = 0;

        setStats({
          total_members: dashboardData.data?.total_user_count ?? 0,
          unread_announcements: unreadCount,
          upcoming_events: dashboardData.data?.upcoming_event_count ?? 0,
        });
      } catch (err) {
        console.error("Dashboard error:", err);
        toast.error("Network error — please try again.", { theme: "colored" });
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div className="bottom-content">
          <h5>Welcome to RCCG, New Beginning Chapel Membership Portal</h5>

          {loading ? (
            <p className="text-center my-5">Loading dashboard...</p>
          ) : (
            <>
              <div className="row dashboardrow">
                <div className="col-md-4">
                  <div className="dashboard-card">
                    <div>
                      <h6>Total Members Today:</h6>
                      <h2 className="members">{stats.total_members}</h2>
                      <p>
                        Total verified members in the church community on this
                        portal
                      </p>
                    </div>
                    <img src={members} alt="" width="90px" />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="dashboard-card">
                    <div>
                      <h6>Unread Announcements</h6>
                      <h2 className="announce">{stats.unread_announcements}</h2>
                      <p>
                        Track unread announcements to stay updated and informed.
                      </p>
                    </div>
                    <img src={announcement} alt="" width="90px" />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="dashboard-card">
                    <div>
                      <h6>Upcoming Events</h6>
                      <h2 className="event">{stats.upcoming_events}</h2>
                      <p>
                        Quick insights into all upcoming events and attendance.
                      </p>
                    </div>
                    <img src={events} alt="" width="90px" />
                  </div>
                </div>
              </div>

              <div className="explore-card">
                <h5>Explore</h5>
                <div className="row">
                  <div className="col-md-4">
                    <div className="blue-card">
                      <img src={logo} alt="" />
                      <h6>Resources</h6>
                      <p className="text-white">
                        Tools and wisdom for building a strong, faith-filled
                        life
                      </p>
                      <a href="/resources">Learn More</a>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="blue-card">
                      <img src={logo} alt="" />
                      <h6>Singles' Fellowship & Growth</h6>
                      <p className="text-white">
                        A space for single adults to connect, serve, and thrive
                        in Christ.
                      </p>
                      <a href="/singlesfellowship">Learn More</a>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="blue-card">
                      <img src={logo} alt="" />
                      <h6>Volunteering</h6>
                      <p className="text-white">
                        Serve with purpose in your church community.
                      </p>
                      <a href="/volunteering">Learn More</a>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
